<script setup>
import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import { labelFor, dotClassFor } from './inboxStatusMeta';

const props = defineProps({
  inboxId: { type: [Number, String], required: true },
});

const byInboxId = useMapGetter('bmtInboxHealth/byInboxId');
const entry = computed(() => byInboxId.value?.[props.inboxId] || null);

// So renderiza se houver status de canal WhatsApp (Evolution ou Cloud) pra este inbox.
const show = computed(() => Boolean(entry.value));
const status = computed(() => entry.value?.status);
const label = computed(() => labelFor(status.value));
const dotClass = computed(() => dotClassFor(status.value));
</script>

<template>
  <span
    v-if="show"
    v-tooltip.top-end="label"
    class="size-2 rounded-full shrink-0"
    :class="dotClass"
  />
</template>
